import React from "react";
import { connect } from "react-redux";
import { Field, getFormValues, InjectedFormProps, reduxForm } from "redux-form";
import moment from "moment";

import { TextInputComponent } from "../InputComponents/TextInputComponent";

interface OwnProps {
    onSubmitConfirm: (birthday: string) => Promise<void>;
    answerSending?: boolean;
    errorMessage?: string | null;
    locked?: boolean;
    attemptsLeft?: number;
}

interface StateProps {
    formValues: any;
    i18n: any;
}

type Props = OwnProps & StateProps;

const formName = "ConfirmBirthdayForm";
class ConfirmBirthdayForm extends React.Component<Props & InjectedFormProps<{}, any>, {}> {
    onSubmitConfirm = async (values: any) => {
        if (this.props.locked) {
            return;
        }
        var date;
        if (values && values?.year && values?.year.length >= 4 && values?.month && values?.day) {
            date = moment(`${values.year}-${values.month}-${values.day}`, 'YYYY-M-D');
        }
        await this.props.onSubmitConfirm(date ? date.format("YYYY-MM-DD") : "");
    };

    render() {
        const { handleSubmit, error, formValues, i18n, answerSending, errorMessage, locked, attemptsLeft } = this.props;

        let date;
        if (formValues && formValues.year && formValues.year.length >= 4 && formValues.month && formValues.day) {
            date = moment(`${formValues.year}-${formValues.month}-${formValues.day}`, 'YYYY-M-D');
        }

        return (
            <>
                <div className="column surveyContainer">
                    <div className="columns is-justify-content-center mt-4">
                        <div className="column questionContainer">
                            <form style={{ width: '100%' }} onSubmit={handleSubmit((values: any) => this.onSubmitConfirm(values))} >
                                {locked ? (
                                    <div className="column answerContainer paddedAnswerContainer">
                                        <div className="columns">
                                            <div className="column questionHeader">{i18n.TooManyAttempts}</div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="column answerContainer paddedAnswerContainer">
                                        <div className="columns">
                                            <div className="column questionHeader">{i18n.ConfirmIdentity}</div>
                                        </div>
                                        <div className="columns">
                                            <div className="column addingInformation">{i18n.ConfirmBirthDate}</div>
                                        </div>

                                        <><div className="columns " style={{ display: 'flex', alignItems: 'center' }}>
                                            <div className="column is-2">
                                                <Field
                                                    component={TextInputComponent}
                                                    type="number"
                                                    isBorderError={true}
                                                    name={'day'}
                                                    placeholder="dd"
                                                />
                                            </div>
                                            <div className="column is-2">
                                                <Field
                                                    component={TextInputComponent}
                                                    type="number"
                                                    name={'month'}
                                                    placeholder="mm"
                                                />
                                            </div>
                                            <div className="column is-2">
                                                <Field
                                                    component={TextInputComponent}
                                                    type="number"
                                                    name={'year'}
                                                    placeholder="yyyy"
                                                />
                                            </div>

                                        </div>

                                            <div className="columns " style={{ display: 'flex', alignItems: 'center' }}>
                                                <div className="column">
                                                    {date && date?.isValid() &&
                                                        date.format('LL').toString()
                                                    }
                                                </div>
                                            </div>
                                        </>


                                        {errorMessage && <strong className="errorMessage">{errorMessage}</strong>}
                                        {error && <strong className="errorMessage">{error}</strong>}
                                    </div>
                                )}
                                {!locked && (
                                    <div className="colums nextButtonColumn" style={{ display: "flex" }}>
                                        <div className="column" style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                                            {attemptsLeft !== undefined && errorMessage && (
                                                <div className="errorMessage" style={{ marginBottom: "8px" }}>
                                                    {i18n.AttemptsLeft ?? "Pogingen over"}: {attemptsLeft}
                                                </div>
                                            )}
                                            <button type="submit" className="blueButton" disabled={answerSending || locked}>{i18n.Confirm}</button>
                                        </div>
                                    </div>
                                )}

                            </form>
                        </div >
                    </div >
                </div >
            </>
        );
    }
}

const mapStateToProps = (state: any): StateProps => {
    return {
        formValues: getFormValues(formName)(state) as any,
        i18n: state.i18n,
    };
};

const ConfirmBirthdayReduxForm = reduxForm<{}, Props>({
    form: formName,
    keepDirtyOnReinitialize: false,
    enableReinitialize: false,
    destroyOnUnmount: true,
    forceUnregisterOnUnmount: true,
})(ConfirmBirthdayForm);

export default connect(mapStateToProps)(ConfirmBirthdayReduxForm);